import errorPage from '../../assets/images/errors/banner_560x430_login.svg';

import { Grid, useMediaQuery, useTheme } from '@mui/material';
import { Box } from '@mui/system';
import React from 'react';
import { VdsButton } from '../../@vds';
import { useLoaderContext } from '../../contexts/LoaderContext';

export const LoginPage: React.FC = () => {
    const theme = useTheme();
    const matches = useMediaQuery(theme.breakpoints.up(970));
    const setLoader = useLoaderContext();

    React.useEffect(() => {
        setLoader(false);
    }, []);

    return (
        <Grid height="100%" container>
            {matches && (
                <Grid sm={6} sx={{ backgroundColor: '#E5EAF0', display: 'flex', alignItems: 'center', justifyContent: 'center' }} item>
                    <img src={errorPage} alt='genericPage' />
                </Grid>
            )}
            <Grid
                sm={matches ? 6 : 12}
                display="flex"
                justifyContent="center"
                flexDirection="column"
                sx={{ background: "#fff" }}
                item
            >
                <Box
                    gap="80px"
                    overflow="auto"
                    sx={{ px: "40px", pb: "40px" }}
                >
                    <Box sx={{
                        fontFamily: "Roboto",
                        fontSize: "24px",
                        fontWeight: 700,
                        lineHeight: "32px",
                        textAlign: "left",
                        color: '#0076ad'
                    }}>
                        Accedi
                    </Box>
                    <Box sx={{
                        color: "rgb(21, 41, 53)",
                        fontFamily: "Roboto",
                        fontSize: "14px",
                        fontWeight: 400,
                        lineHeight: "20px",
                        textAlign: "left"
                    }}>
                        <br />
                        <br />
                        Logout completato con successo.
                        <br />
                        <br />
                        Accedi utilizzando l’indirizzo e-mail al quale al quale è stata condivisa la promozione.
                        <br />
                        <br />
                        Se riscontri difficoltà nell'accesso, contatta il tuo referente commerciale TeamSystem oppure su <a href="https://mrk.teamsystem.com/ts-cybersecurity-contatto-sw">https://mrk.teamsystem.com/ts-cybersecurity-contatto-sw</a>
                        <br />
                        <br />
                    </Box>
                    <Box>
                        <VdsButton variant="contained" color="primary" onClick={() => {
                            window.location.href = "/Account/OnPostLogin";
                        }}>
                            Accedi
                        </VdsButton>
                    </Box>
                </Box>
            </Grid>
        </Grid>
    );
};
